var render = function render(){var _vm=this,_c=_vm._self._c;return _c('main',{staticClass:"Oauth"},[_c('loading-spinner',{attrs:{"full-page":""}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }